import type { FC } from 'react';

import { CabinetBanner } from 'components/CabinetBanner';
import { useProfileModeration } from 'hooks/useProfileModeration';
import { useVerificationEdits } from 'hooks/useVerificationEdits';

export const StudentModeratorCommentBanner: FC = () => {
  const { status, comment } = useProfileModeration();
  const { hasRejectedItems } = useVerificationEdits();

  if (!comment?.trim()) {
    return null;
  }

  if (status !== 'rejected' && status !== 'changes_requested') {
    return null;
  }

  const title =
    status === 'rejected' ? 'Профиль не прошел проверку' : 'Нужно уточнить данные';

  return (
    <CabinetBanner
      variant='warning'
      title={title}
      text={comment.trim()}
      linkTo={hasRejectedItems ? '/profile/edits' : '/profile'}
      linkLabel={
        hasRejectedItems ? 'Смотреть замечания модератора' : 'Исправить данные'
      }
    />
  );
};
